import React from "react";
import Slide from "../../utils/images/slide-1.jpg";
import styled from "styled-components";

const Layout = styled.div`
  background: #f6f6f6;
  font-family: "Oswald" sans-serif;
  padding-top: 40px;

  .card-wrapper {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    justify-content: center;
    padding: 20px 15%;
    grid-gap: 15px 30px;
    @media (max-width: 767px) {
      grid-template-columns: 1fr;
      padding: 20px 5%;
      font-size: 130%;
    }
    @media (width: 768px) {
      grid-template-columns: 1fr 1fr;
      padding: 20px 5%;
    }
  }
  .img-style {
    width: 100%;
    max-width: 377px;
    height: 277px;
    object-fit: cover;
  }
  .card {
    background-color: #fff;
    padding: 40px;
    margin-bottom: 30px;
    display: grid;
    @media (max-width: 768px) {
      padding: 20px;
      font-weight: lighter;
    }
  }
  .cardContent {
    justify-self: flex-end;
  }
  .jus {
    /* justify-self: flex-end; */
  }
`;

function LocatonCard() {
  return (
    <>
      <Layout>
        <div className="card-wrapper">
          <div className="card ">
            <div className="cardContent">
              <h3>CEREMONY LOCATION</h3>
              <h5>Foxegan Hotel, 2nd Floor, Room 8</h5>
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer
                ultrices malesuada ante quis pharetra. Nullam non bibendum
                dolor. Ut vel turpis accumsan, efficitur dolor fermentum,
                tincidunt metus. Etiam ut ultrices nibh. Etiam
              </p>
              <div style={styles.cardImg}>
                <img src={Slide} className="img-style" alt="mypix" />
              </div>
            </div>
          </div>
          <div className="card">
            <div className="cardContent">
              <h3>PARTY LOCATION</h3>
              <h5>Foxegan Hotel, 2nd Floor, Room 8</h5>
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer
                ultrices malesuada ante quis pharetra. Nullam non bibendum
                dolor. Ut vel turpis accumsan, efficitur dolor fermentum,
                tincidunt metus. Etiam ut ultrices nibh. Etiam
              </p>
              <div style={styles.cardImg}>
                <img src={Slide} className="img-style" alt="" />
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </>
  );
}

const styles = {
  cardImg: { marginTop: 37 },
};

export default LocatonCard;
